import styled from 'styled-components'


export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const Text = styled.textarea`
  flex: 1;
  margin-top: 10px;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  padding: 10px;
  resize: none;
  color: #63a5c0;
  background-color: #fdfdfd;
  border: 1px solid #c6dee9;
  border-radius: 10px;
  font-size:14px;
  height: 90%;
  max-width: 100%;
  width: -webkit-fill-available;
`
